const ContactsUnavailable = () => {
  return (
    <svg
      width="160"
      height="141"
      viewBox="0 0 160 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M115.958 2.65904C116.682 2.65904 117.268 2.07254 117.268 1.34905C117.268 0.625565 116.682 0.0390625 115.958 0.0390625C115.235 0.0390625 114.648 0.625565 114.648 1.34905C114.648 2.07254 115.235 2.65904 115.958 2.65904Z"
        fill="#0B4EDB"
      />
      <path
        d="M125.091 93.245C125.815 93.245 126.401 92.6585 126.401 91.935C126.401 91.2115 125.815 90.625 125.091 90.625C124.368 90.625 123.781 91.2115 123.781 91.935C123.781 92.6585 124.368 93.245 125.091 93.245Z"
        fill="#CFCFCF"
      />
      <path
        d="M107.726 48.376C96.5097 48.376 85.1172 47.9197 74.4606 44.9611C63.804 42.0026 54.4428 36.4241 45.8174 29.9036C40.2095 25.6498 35.0873 22.2792 27.8308 22.7943C20.7137 23.1731 13.9072 25.8307 8.41642 30.3746C-0.900715 38.4848 0.571183 53.4835 4.25094 64.0223C9.81472 79.9188 26.7563 90.9433 41.1515 98.1409C57.784 106.442 76.0503 111.27 94.3754 114.052C110.566 116.496 131.07 118.262 144.979 107.767C157.77 98.1409 161.273 76.136 158.138 61.2845C157.379 56.8951 155.045 52.9333 151.573 50.1422C142.595 43.5776 129.201 47.9638 119.103 48.1846C115.379 48.2729 111.553 48.3612 107.726 48.376Z"
        fill="#DDEFFD"
      />
      <path
        d="M152.203 27.1562V32.9261"
        stroke="#0B4EDB"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.328 30.0547H155.083"
        stroke="#0B4EDB"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.28125 97.0078V102.778"
        stroke="#0B4EDB"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.40625 99.8984H7.16137"
        stroke="#0B4EDB"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.3126 140.068C107.439 140.068 129.43 138.698 129.43 137.007C129.43 135.316 107.439 133.945 80.3126 133.945C53.1859 133.945 31.1953 135.316 31.1953 137.007C31.1953 138.698 53.1859 140.068 80.3126 140.068Z"
        fill="#99CFF8"
      />
      <path
        d="M134.788 28.6331L33.0947 19.6288C30.1472 19.3678 27.5462 21.5456 27.2853 24.4931L20.9539 95.9979C20.693 98.9454 22.8708 101.546 25.8182 101.807L127.511 110.812C130.459 111.073 133.06 108.895 133.321 105.947L139.652 34.4425C139.913 31.495 137.735 28.8941 134.788 28.6331Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M110.21 54.7758L52.7073 49.6843C51.3631 49.5652 50.177 50.5584 50.0579 51.9026L49.7035 55.9052C49.5845 57.2494 50.5777 58.4355 51.9219 58.5545L109.425 63.6461C110.769 63.7651 111.955 62.7719 112.074 61.4278L112.429 57.4251C112.548 56.081 111.554 54.8948 110.21 54.7758Z"
        fill="#BAAAE9"
      />
      <path
        d="M108.671 72.0649L51.1682 66.9733C49.824 66.8543 48.6379 67.8475 48.5189 69.1916L48.1645 73.1943C48.0454 74.5384 49.0386 75.7246 50.3828 75.8436L107.886 80.9351C109.23 81.0542 110.416 80.061 110.535 78.7168L110.89 74.7142C111.009 73.37 110.015 72.1839 108.671 72.0649Z"
        fill="#BAAAE9"
      />
      <path
        d="M88.1482 87.9735L68.6042 86.243C67.5758 86.1519 66.6684 86.9118 66.5773 87.9402L66.1216 93.0864C66.0306 94.1148 66.7904 95.0222 67.8188 95.1133L87.3628 96.8438C88.3911 96.9349 89.2986 96.175 89.3897 95.1466L89.8453 90.0004C89.9364 88.972 89.1766 88.0646 88.1482 87.9735Z"
        fill="#522AC7"
      />
      <path
        d="M97.3627 23.6698C97.3627 27.0409 96.363 30.3363 94.4901 33.1393C92.6172 35.9423 89.9552 38.1269 86.8407 39.417C83.7262 40.7071 80.2991 41.0446 76.9928 40.3869C73.6865 39.7293 70.6494 38.1059 68.2657 35.7222C65.882 33.3385 64.2586 30.3014 63.601 26.9951C62.9433 23.6888 63.2808 20.2616 64.5709 17.1472C65.861 14.0327 68.0456 11.3706 70.8486 9.49776C73.6515 7.62488 76.9469 6.62523 80.3181 6.62523C82.5597 6.61353 84.7813 7.04641 86.8546 7.89883C88.9278 8.75126 90.8114 10.0063 92.3965 11.5914C93.9816 13.1765 95.2366 15.0601 96.0891 17.1333C96.9415 19.2066 97.3744 21.4282 97.3627 23.6698Z"
        fill="#DCD4F4"
        stroke="#522AC7"
        strokeWidth="1.4719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.2919 34.7596C91.6945 36.6247 89.7124 38.122 87.4816 39.1485C85.2508 40.1751 82.8242 40.7066 80.3686 40.7066C77.913 40.7066 75.4864 40.1751 73.2556 39.1485C71.0248 38.122 69.0427 36.6247 67.4453 34.7596C67.6666 31.4829 69.1244 28.4126 71.5236 26.1699C73.9228 23.9272 77.0844 22.6797 80.3686 22.6797C83.6528 22.6797 86.8144 23.9272 89.2136 26.1699C91.6128 28.4126 93.0706 31.4829 93.2919 34.7596Z"
        fill="#522AC7"
      />
      <path
        d="M80.312 20.1005C83.401 20.1005 85.9052 17.5963 85.9052 14.5073C85.9052 11.4182 83.401 8.91406 80.312 8.91406C77.2229 8.91406 74.7188 11.4182 74.7188 14.5073C74.7188 17.5963 77.2229 20.1005 80.312 20.1005Z"
        fill="#522AC7"
      />
    </svg>
  );
};
export default ContactsUnavailable;
